import React from 'react';
import moment from 'moment';
import Print from 'Print';

// Services
import API from 'API';

// Components
import Loader from 'components/common/Loader';
import SuperTable from 'components/common/SuperTable';
import DatePicker from 'components/common/DatePicker';
import EditInvoiceModal from 'components/invoice/EditInvoiceModal';

class ListInvoices extends React.Component {

    constructor(props) {
        super(props);

        this.editInvoiceModalRef = React.createRef();

        this.state = {
            invoices: [],
            isLoading: true,
            filters: {
                dateFrom: null,
                dateTo: null,
                status: 'unpaid',
                manuallyRaisedOnly: true
            }
        };
    }

    componentDidMount() {
        this.props.fns.setTitle('Invoices');
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.type !== this.props.type) {
            this.load();
        }
    }

    async load() {
        this.setState({ isLoading: true });
        const { filters } = this.state;
        const invoices = await API.call('invoice/list', filters);
        this.setState({ invoices, isLoading: false });
    }

    updateFilters(values) {
        const filters = { ...this.state.filters };
        let isChanged = false;
        for (let fieldName in values) {
            const value = values[fieldName];
            if (value != filters[fieldName]) {
                filters[fieldName] = value;
                isChanged = true;
            }
        }
        this.setState({ filters, isLoading: isChanged }, () => {
            if (isChanged) this.load();
        });
    }

    async showEditInvoiceModal(id) {
        await this.editInvoiceModalRef.current.open({
            id
        });
        this.load();
    }

    render() {
        const { invoices, isLoading, filters } = this.state;

        if (isLoading) return (<Loader />);

        const cols = {
            number: {
                label: 'Number',
                className: 'number-col'
            },
            customerName: {
                label: 'Customer'
            },
            appts: {
                label: 'Appt(s)',
                getValue: (colInfo, row) =>
                    row.appts.map((a, index) =>
                        <span key={index}>
                            {moment(a.date).format('DD/MM/YYYY')}

                            <button className="btn btn-secondary btn-sm ms-2" onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                const url = `/calendar/?date=${moment(a.date).format('YYYY-MM-DD')}&apptID=${a.id}`;
                                this.props.history.push(url);
                            }}>
                                <span className="fa-solid fa-calendar-day" title="View in calendar" />
                            </button>
                        </span>
                    ).reduce((prev, curr) => [prev, ', ', curr])
            },
            manuallyRaised: {
                label: 'Manually raised',
                className: 'manually-raised-col',
                getValue: (colInfo, row) => row.isManuallyRaised ?
                    <span className="fa-solid fa-check text-success" title="Manually raised" /> :
                    null
            },
            value: {
                label: 'Value',
                type: 'currency'
            },
            balance: {
                label: 'Balance',
                type: 'currency'
            },
            actions: {
                label: '',
                className: 'actions-col',
                getValue: (colInfo, row) => <>
                    <button className="btn btn-secondary btn-sm" onClick={async e => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.showEditInvoiceModal(row.id);
                    }}>
                        <span className="fa-solid fa-pencil-alt" /> Edit
                    </button>

                    <button className="btn btn-secondary btn-sm  ms-2" onClick={async e => {
                        e.preventDefault();
                        e.stopPropagation();
                        await Print.url('/api/invoice/get-pdf/' + row.id, { isInline: true });
                    }}>
                        <span className="fa-solid fa-print" /> Print
                    </button>

                    <button className="btn btn-secondary btn-sm  ms-2" onClick={async e => {
                        e.preventDefault();
                        e.stopPropagation();
                        await Print.url('/api/invoice/get-pdf/' + row.id, { isInline: false });
                    }}>
                        <span className="fa-solid fa-download" /> Download
                    </button>
                </>
            }
        };

        return (<>
            <section className="control-panel list-invoices-page">

                <select
                    className="form-control"
                    value={filters.status || ''}
                    onChange={e => this.updateFilters({ status: e.target.value })}
                    style={{ width: 150 }}
                >
                    <option value="">All statuses</option>
                    <option value="unpaid">Unpaid</option>
                    <option value="paid">Paid</option>
                </select>

                <label className="ms-3 form-check" style={{display: 'inline-flex', alignItems: 'center'}}>
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={!!filters.manuallyRaisedOnly}
                        onChange={e => this.updateFilters({ manuallyRaisedOnly: e.target.checked })}
                    />
                    <span className="form-check-label ms-2">Manually raised only</span>
                </label>

                {invoices &&
                    <div className="control-panel-component ms-3">
                        Number of items: {invoices.length}
                    </div>
                }

                <div className="control-panel-component ms-auto">

                    <DatePicker
                        className="form-control"
                        wrapperClassName="date-picker"
                        value={filters.dateFrom}
                        onChange={date => this.updateFilters({ dateFrom: date })}
                        placeholderText="Date (from)"
                    />

                    <DatePicker
                        className="form-control ms-2"
                        wrapperClassName="date-picker"
                        value={filters.dateTo}
                        onChange={date => this.updateFilters({ dateTo: date })}
                        placeholderText="Date (to)"
                    />

                </div>

            </section>

            <section>

                <div className="sticky-table-container">

                    <SuperTable
                        className="invoices-table table table-bordered mb-0"
                        rows={invoices}
                        keyAccessor={i => i.id}
                        cols={cols}
                        emptyText="No invoices"
                    />

                </div>

            </section>

            <EditInvoiceModal ref={this.editInvoiceModalRef} {...this.props} />

        </>);
    }
}

export default ListInvoices;
